export default [
  // ===== SI units
  {sid: 'si-units-units', symbol: 'units', name: 'units', ratio: 1},
  // volume
  {sid: 'si-vol-ml', symbol: 'ml', name: 'mililitres', ratio: 1},
  {sid: 'si-vol-cl', symbol: 'cl', name: 'centilitres', ratio: 10},
  {sid: 'si-vol-l', symbol: 'l', name: 'litres', ratio: 1000},
  {sid: 'si-vol-kl', symbol: 'kl', name: 'kilolitres', ratio: 1000000},
  // mass
  {sid: 'si-mass-mg', symbol: 'mg', name: 'miligrams', ratio: 1},
  {sid: 'si-mass-g', symbol: 'g', name: 'grams', ratio: 1000},
  {sid: 'si-mass-kg', symbol: 'kg', name: 'kilograms', ratio: 1000000},
  // length
  {sid: 'si-len-mm', symbol: 'mm', name: 'milimetres', ratio: 1},
  {sid: 'si-len-cm', symbol: 'cm', name: 'centimetres', ratio: 10},
  {sid: 'si-len-m', symbol: 'm', name: 'metres', ratio: 1000},
  // ===== BI units
  {sid: 'bi-units-units', symbol: 'units', name: 'units', ratio: 1},
  // volume
  {sid: 'bi-vol-floz', symbol: 'fl oz', name: 'fluid ounce', ratio: 28.4130625},
  {sid: 'bi-vol-gi', symbol: 'gi', name: 'gill', ratio: 142.0653125},
  {sid: 'bi-vol-pt', symbol: 'pt', name: 'pint', ratio: 568.26125},
  {sid: 'bi-vol-qt', symbol: 'qt', name: 'quart', ratio: 1136.5225},
  {sid: 'bi-vol-gal', symbol: 'gal', name: 'gallon', ratio: 4546.09}
]
